import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { map, pick } from 'lodash'
import { createCalendarLinks } from 'LiveBoard/api/calendarLinks'
import CalendarLink from './CalendarLink'

import './style.css.scss'

const CALENDAR_SERVICES = {
  apple: 'APPLE',
  google: 'GOOGLE',
  outlookcom: 'OFFICE 365',
  outlook: "OUTLOOK",
  yahoo: "YAHOO"
}

const CalendarLinksContainer = ({board, lead}) => {
  const [calendaerLinks, setCalendarLinks] = useState({})
  
  const calendarLinksParams = {
    boardId: board.id,
    leadData: pick(lead, ['name', 'last_name', 'email'])
  }
  
  useEffect(() => {
    createCalendarLinks(calendarLinksParams)
      .then(links => { setCalendarLinks(links)})
  }, [])
  
  return (
    <div className="calendar-links-container">
      <p className="title">
        Add to your calendar:
      </p>
      
      <div className='calendar-links-buttons'>
        {map(CALENDAR_SERVICES, (value, key) => {
          return ( 
            <CalendarLink
              key={key} 
              serviceName={value} 
              url={calendaerLinks[key]} />
          )
        })}
      </div>
    </div>
  )
}

CalendarLinksContainer.propTypes = {
  lead: PropTypes.object,
  board: PropTypes.object
}

const mapStateToProps = ({ lead, board }) => {
  return {
    lead,
    board
  }
}
  
export default connect(mapStateToProps, null)(CalendarLinksContainer)
  